var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirmation',{on:{"interact":_vm.onInteractive},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v(" 開啟音效"),_c('br'),_vm._v("獲得最佳互動體驗 ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }